import {
  type ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@shared-components/shadcn/chart";
import { api } from "@shared-server/api";
import {
  Bar,
  ComposedChart,
  CartesianGrid,
  Line,
  XAxis,
  YAxis,
  Legend,
} from "recharts";
import { formatGranularDateTick } from "./metric-utils";
import type { GranularityType } from "@shared-server/api/routers/queries/metrics/utils";
import { useDepartmentStackContext } from "@shared-components/department-stack-provider";

const chartConfig: ChartConfig = {
  count: {
    label: "Chats",
  },
};

type ChatsProps = {
  startDate: Date;
  endDate: Date;
  granularity: GranularityType;
};

export const Chats = (props: ChatsProps) => {
  const { parentDepartmentId } = useDepartmentStackContext();
  // Query
  const coreMetricsQuery = api.coreMetrics.chatsAttempted.useQuery({
    startDate: props.startDate,
    endDate: props.endDate,
    granularity: props.granularity,
    parentDepartmentId: parentDepartmentId,
  });
  const chartData = coreMetricsQuery.data?.chartData ?? [];

  return (
    <div>
      <h2 className="mb-4">{"Chats"}</h2>
      <ChartContainer
        config={chartConfig}
        className="aspect-auto h-[150px] w-full"
      >
        <ComposedChart accessibilityLayer data={chartData}>
          <CartesianGrid vertical={false} />
          <XAxis
            dataKey="date"
            tickLine={false}
            axisLine={false}
            tickMargin={8}
            minTickGap={32}
            tickFormatter={(value: string) =>
              formatGranularDateTick(value, props.granularity)
            }
          />
          <YAxis
            yAxisId="countItems"
            dataKey={"countItems"}
            interval={1}
            orientation="left"
          />
          <YAxis
            yAxisId="countItemsCumulative"
            dataKey={"countItemsCumulative"}
            interval={1}
            orientation="right"
          />
          <ChartTooltip
            content={
              <ChartTooltipContent
                nameKey="date"
                labelFormatter={(value: string) => {
                  return value;
                }}
              />
            }
          />
          <Legend />
          <Bar
            yAxisId="countItems"
            dataKey={"countItems"}
            className="fill-ter-blue-500"
            fill="#006e96"
          />
          <Line
            yAxisId="countItemsCumulative"
            dataKey={"countItemsCumulative"}
            dot={false}
            className="fill-ter-blue-500"
            stroke="#006e96"
          />
        </ComposedChart>
      </ChartContainer>
    </div>
  );
};
